import { render, staticRenderFns } from "./SelectedServiceFeeTable.vue?vue&type=template&id=21536b76&"
import script from "./SelectedServiceFeeTable.vue?vue&type=script&lang=js&"
export * from "./SelectedServiceFeeTable.vue?vue&type=script&lang=js&"
import style0 from "./SelectedServiceFeeTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports